'use client'
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/productAction.ts
var PRODUCT_ACTION_QUERY = `
sys { id }
id
title
prefix
suffix
type
message
messageColor
messageBgColor
currencyCode
startingPrice
discountedPrice
icon{${IMAGE_QUERY}}
link{${LINK_QUERY}}
`;

export {
  PRODUCT_ACTION_QUERY
};
//# sourceMappingURL=chunk-7KH2SW6P.mjs.map